import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface EnabledDoc {
  id: number;
  documentName: string;
  enabled: boolean;
  enabledAt: string; 
}

export interface EnabledDocumentFormValues {
  documentTypeId: number | null;
}

export interface EnabledDocumentErrors {
  documentTypeId?: string;
}

interface State {
  enabledDocuments: EnabledDoc[];
  form: EnabledDocumentFormValues;
  formErrors: EnabledDocumentErrors;
  isSubmit: boolean;
  isCreateModalOpen: boolean;
}

export const initialForm: EnabledDocumentFormValues = {
  documentTypeId: null,
};

const initialState: State = {
  enabledDocuments: [],
  form: initialForm,
  formErrors: {},
  isSubmit: false,
  isCreateModalOpen: false,
};

export const enabledDocumentTypesSlice = createSlice({
  name: "enabledDocumentTypes",
  initialState,
  reducers: {

    // ===========================
    // LIST / UPDATE LIST
    // ===========================
    setEnabledDocuments: (state, action: PayloadAction<EnabledDoc[]>) => {
      state.enabledDocuments = action.payload;
    },

    addEnabledDocument: (state, action: PayloadAction<EnabledDoc>) => {
      state.enabledDocuments.push(action.payload);
    },

    toggleDocumentState: (
      state,
      action: PayloadAction<{ id: number; enabled: boolean }>
    ) => {
      state.enabledDocuments = state.enabledDocuments.map(doc =>
        doc.id === action.payload.id
          ? { ...doc, enabled: action.payload.enabled }
          : doc
      );
    },

    // ===========================
    // FORM
    // ===========================
    updateFormField: (
      state,
      action: PayloadAction<{ field: keyof EnabledDocumentFormValues; value: any }>
    ) => {
      state.form[action.payload.field] = action.payload.value;
    },

    resetForm: (state) => {
      state.form = initialForm;
      state.formErrors = {};
      state.isSubmit = false;
    },

    // ===========================
    // ERRORS
    // ===========================
    setFormErrors: (state, action: PayloadAction<EnabledDocumentErrors>) => {
      state.formErrors = action.payload;
    },

    clearFormErrors: (state) => {
      state.formErrors = {};
    },

    // ===========================
    // SUBMIT STATUS
    // ===========================
    setSubmit: (state, action: PayloadAction<boolean>) => {
      state.isSubmit = action.payload;
    },

    // ===========================
    // MODAL CONTROL
    // ===========================
    openCreateModal: (state) => {
      state.isCreateModalOpen = true;
    },

    closeCreateModal: (state) => {
      state.isCreateModalOpen = false;
    },
  },
});

export const {
  setEnabledDocuments,
  addEnabledDocument,
  toggleDocumentState,
  updateFormField,
  resetForm,
  setFormErrors,
  clearFormErrors,
  setSubmit,
  openCreateModal,
  closeCreateModal,
} = enabledDocumentTypesSlice.actions;

export default enabledDocumentTypesSlice.reducer;
